var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"div",staticClass:"ys-float-btn",style:({
    width: _vm.itemWidth + 'px',
    height: _vm.itemHeight + 'px',
    left: _vm.left + 'px',
    top: _vm.top + 'px'
  }),on:{"click":_vm.onBtnClicked,"mouseover":_vm.hoverListener,"mouseout":_vm.mouseoutListener}},[_c('v-icon',[_vm._v("mdi-settings")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }